import Api from "../common/Api";
import {
  BillListHeaderDataModel,
  BillListStatusModel,
  BillListStatusMonthModel,
  BillSaveModel, BillUpdatePaidStatus, ReqdModel
} from "app/model/cb/billModel";
import { CoUserModel } from "app/model/common/coUserModel";

export class BillService extends Api {
  private static service: BillService;

  public static getInstance(): BillService {
    if(!BillService.service) {
      BillService.service = new BillService();
    }
    return BillService.service;
  }

  public async getBillDashboardBuy() {
    const url = process.env.REACT_APP_URL_CB + '/bill/db/buy';
    return await super.get<BillListHeaderDataModel>(url);
  }

  public async getBillDashboardSell() {
    const url = process.env.REACT_APP_URL_CB + '/bill/db/sell';
    return await super.get<BillListHeaderDataModel>(url);
  }

  public async getBillListStatus() {
    const url = process.env.REACT_APP_URL_CB + '/bill/status/year';
    return await super.get<BillListStatusModel>(url);
  }

  public async getBillListStatusMonth(month: string) {
    const url = process.env.REACT_APP_URL_CB + '/bill/status/' + month;
    return await super.get<BillListStatusMonthModel>(url);
  }

  public async getBillHDStatusMonth(month: string) {
    const url = process.env.REACT_APP_URL_CB + '/bill/status/hd/' + month;
    return await super.get<BillListStatusMonthModel>(url);
  }

  public async getBillDCStatusMonth(month: string) {
    const url = process.env.REACT_APP_URL_CB + '/bill/status/dc/' + month;
    return await super.get<BillListStatusMonthModel>(url);
  }

  public async getBillHDCheckHasReqd(data: any) {
    const url = process.env.REACT_APP_URL_CB + '/bill/form/check/hd';
    return await super.get<boolean>(url, data);
  }

  public async getBillPPACheckHasReqd(data: any) {
    const url = process.env.REACT_APP_URL_CB + '/bill/form/check/ppa';
    return await super.get<boolean>(url, data);
  }

  public async getBillDetail(reqId: string) {
    const url = process.env.REACT_APP_URL_CB + '/bill/bill';
    return await super.get<ReqdModel>(url, { reqId: reqId });
  }

  public async getSalerUserInfo() {
    const url = process.env.REACT_APP_URL_CB + '/bill/bill/saler';
    return await super.get<CoUserModel>(url);
  }

  public async saveBill(data: BillSaveModel) {
    const url = process.env.REACT_APP_URL_CB + '/bill/bill';
    return await super.post<ReqdModel>(url, data);
  }

  public async updateTaxCheckStatus(data: BillSaveModel) {
    const url = process.env.REACT_APP_URL_CB + '/bill/bill';
    return await super.put<ReqdModel>(url, data);
  }

  public async updatePaidStatus(data: BillUpdatePaidStatus) {
    const url = process.env.REACT_APP_URL_CB + '/bill/list/status';
    return await super.put<boolean>(url, data);
  }
}